function changeDMSIntoDecimal(coordinates) {
    let latLong;

    if (coordinates[2] === ".") {
        console.log("we got someone here", coordinates)
        latLong = +coordinates;
    } else {
        const fullDegrees = +coordinates.substring(0,2);
        const minutes = +coordinates.substring(3,5);
        let seconds;

        if (coordinates.substring(6,8).length === 2) {
            seconds = +coordinates.substring(6,8);
        } else {
            seconds = 0;
        }

        const decimal = ((minutes * 60)+seconds) / (60*60);

        latLong = fullDegrees + decimal;
    }

    return latLong;
}

export function initSitesMap(maps, mapData) {
    if (mapData) {
        const {sites, excavatedBy} = mapData;

        const center = {lat: 35.5, lng: 47.60};
        const map = new maps.Map(document.getElementById('sitesMap'), {
            zoom: 5.4,
            center: center,
            mapTypeId: 'hybrid'
        });

        sites.forEach((site) => {
            const position = {lat: changeDMSIntoDecimal(site.latitude), lng: changeDMSIntoDecimal(site.longitude)};
            if (site.name === "Porphyreon (Jiyeh)") {
                console.log("we have Porphyreon (Jiyeh)", position, site.latitude);
            }
            const links = site.links.map(link => {
                let markup;

                if (link.indexOf('http') === 0) {
                    markup = '<p><a href="' + link + '">' + link + '</p>';
                } else {
                    markup = '<p>' + link + '</p>';
                }

                return markup;
            });

            function createInfoWindowContent() {
                var infoWindowContent = '<div class="info_content">' +
                    '<p><span class="bold">' + site.name + '</span>, ' + site.country + '</p>';

                if (site.quantity) {
                    infoWindowContent += '<p>' + site.quantity + '</p>';
                }

                if (site.dating) {
                    infoWindowContent += '<p>' + site.dating + '</p>';
                }

                if (site.excavatedBy) {
                    infoWindowContent += '<p>' + excavatedBy + ': ' + site.excavatedBy + '</p>';
                }

                infoWindowContent += links.join('') +
                    '</div>';
                return infoWindowContent;
            }

            const infoWindow = new maps.InfoWindow();

            const marker = new maps.Marker({
                position: position,
                map: map,
                title: site.name
            });

            maps.event.addListener(marker, 'click', (function (marker) {
                return function () {
                    infoWindow.setContent(createInfoWindowContent());
                    infoWindow.open(map, marker);
                }
            })(marker));

            maps.event.addListener(map, 'click', (function () {
                infoWindow.close();
            }));
        })
    }
}

